import React from "react";
import styled from "styled-components";

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: #fff;
  stroke-width: 2px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  background: ${(props) => (props.checked ? "#1890ff" : "#fff")};
  border-radius: 3px;
  transition: all 150ms;
  border: 1px solid #1890ff;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 1px #000;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

const Wrapper = styled.label`
  cursor: pointer;
`;

const StyledCheckBoxWithLabel = ({
  children,
  className,
  checked,
  label,
  ...props
}) => (
  <Wrapper>
    <CheckboxContainer className={className}>
      <HiddenCheckbox checked={checked} {...props} />
      <StyledCheckbox checked={checked}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
    {children}
    <span style={{ marginLeft: 4, color:'#000' }}>{label}</span>
  </Wrapper>
);

export default StyledCheckBoxWithLabel;
